module.exports = __webpack_public_path__ + "media/images/margaritis-trucks-logo-b2c18c5e077e3bb5b2c3a1433d0985eb.jpg";